export const facebookSdkInit = data => {
    window.fbAsyncInit = () => {
        // console.log('fbAsyncInit', data)
        window.FB?.init({
            appId: `${data?.messengerAppId}`,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v6.0'
        });

        /*global FB b:true*/
        /*eslint no-undef: "error"*/
        window.FB?.Event?.subscribe('messenger_checkbox', function (e) {
            // console.log('fb_checkbox_click',e)
            if (e.event == 'rendered') {
                console.log('Plugin was rendered')
                document.getElementById('fmsg').style.display = 'block'
            } else if (e.event == 'checkbox') {
                var checkboxState = e.state
                console.log('Checkbox state: ' + checkboxState)

                FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                    'app_id': data?.messengerAppId,
                    'page_id': data?.pageId,
                    'ref': 'support',
                    'user_ref': `${data?.uniqId}`
                })

            } else if (e.event == 'not_you') {
                console.log('User clicked \'not you\'')
            } else if (e.event == 'hidden') {
                console.log('Plugin was hidden')
                document.getElementById('fmsg').style.display = 'none'
            }
        }, function(err){
            console.log(err)
        })
    }
    window.FB = null;
    window.fbAsyncInit.hasRun = false;
    const head = document.getElementsByTagName('head')[0]
    if(document.getElementById('facebook-jssdk')){
        document.getElementById('facebook-jssdk')?.remove()
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'facebook-sdk'
    script.text = `
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) { return; }
                js = d.createElement(s); js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
    `
    head.appendChild(script)
}

export const zendeskInit = props => {
    const {customer, global } = props
    if(customer){
        let level = !customer?.vipUser ? '0': customer?.vipUser?.level;
        window.zESettings = {
            webWidget: {
                offset: {
                    horizontal: '50px',
                    vertical: '0'
                }
            }
        }
        if(window.zE){
            window.zE('webWidget', 'chat:addTags', [global?.config?.name+'','V'+level]);

            window.zE('webWidget:on', 'open', function(){
                window.zE('webWidget', 'show');
            });

            window.zE('webWidget:on', 'close', function(){
                // window.zE('webWidget', 'hide');
            });

            window.zE('webWidget', 'helpCenter:setSuggestions', { search: 'FAQ' });

            window.zE('webWidget', 'hide');
            // $(document).on("click",'#comm100-button-176-react',function(){
            //     console.log('online help click')
            //     window.zE('webWidget', 'show');
            //     window.zE('webWidget', 'open');
            // });

        }
    }

}

export const zendeskClick = () => {
    console.log('online help click')
    if(window.zE){
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
    }
}